module.exports = __webpack_public_path__ + "img/logo-company.9b008622.png";